import React, { useEffect, useState } from "react";
// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import AddTherapistTypeToSession from "./AddTherapistTypeToSession";
import SessionTherapistsTable from "./SessionTherapistsTable";
import { useContext } from "react";
import AddTherapistTypeToSessionReq from "../../../../Classes/Models/Requests/AddManyToManyReq";
import RemoveReq from "../../../../Classes/Models/Requests/SearchStringOrIntReq";
import SessionsApi from "../../../../Classes/API/Administration/SessionsApi";
import Swal from "sweetalert2";
import { LanguageContext } from "App";

const Index = ({ Session, setIsLoaded }) => {
  const { translations } = useContext(LanguageContext);
  const AddToSession = async (TypeId, Qty) => {
    let addReq = new AddTherapistTypeToSessionReq();

    addReq.Id1 = Session.id;
    addReq.Id2 = TypeId;
    addReq.QuantityNeeded = Qty;

    let res = await SessionsApi.AddTherapistTypeToSession(addReq);

    if (res.status == "Success") {
      setIsLoaded(false);
    }
  };

  const RemoveFromSession = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.value) {
        let removeReq = new RemoveReq();
        removeReq.SearchInt = id;
        let res = await SessionsApi.RemoveTherapistTypeFromSession(removeReq);
        if (res.status == "Success") {
          setIsLoaded(false);
          Swal.fire("Deleted!", "Deleted.", "success");
        }
      }
    });
  };

  return (
    <div className="mb-3 col-md-12">
      <div className="card">
        {/* <MDBox display="flex" justifyContent="space-between" alignItems="center" pt={2} px={2}>
          <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
            {translations.sessionPgSessionsManageSessionTherapistTypes}
          </MDTypography>
        </MDBox> */}
        <MDBox p={2}>
          <AddTherapistTypeToSession
            AddToSession={AddToSession}
            setIsLoaded={setIsLoaded}
            Session={Session}
          />

          <SessionTherapistsTable RemoveFromSession={RemoveFromSession} Session={Session} />
        </MDBox>
      </div>
    </div>
  );
};

export default Index;
